<template>
    <div class="serve">
        <navs></navs>
        <banner :img="bannerImg" titleEn="The enterprise service" titleCn="企业服务"></banner>
        <div class="serve_box">
            <div class="all_box">
                <div class="serve_nav_list">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="劳务外包" name="first"></el-tab-pane>
                        <el-tab-pane label="人事代理" name="second"></el-tab-pane>
                        <el-tab-pane label="薪酬服务" name="third"></el-tab-pane>
                        <el-tab-pane label="劳务派遣" name="fourth"></el-tab-pane>
                        <el-tab-pane label="招聘服务" name="fifth"></el-tab-pane>
                        <el-tab-pane label="猎头服务" name="sixth"></el-tab-pane>
                        <el-tab-pane label="商务代理" name="seventh"></el-tab-pane>
                        <el-tab-pane label="法务帮助" name="eighth"></el-tab-pane>
                        <el-tab-pane label="商业保险" name="ninth"></el-tab-pane>
                        <el-tab-pane label="体检服务" name="tenth"></el-tab-pane>
                    </el-tabs>
                </div>
                <div class="serve_body_list">
                    <div class="serve_body_item" ref="itemOne">
                        <div class="serve_body_pic">
                            <div class="serve_body_text">
                                <p>劳务外包服务是浙江橙兰一体化人力资源服务的重要内容之一。劳务外包是指企业将人事管理的部分或全部工作外包给浙江橙兰来完成，可分为项目外包和生产线外包（BPO）。浙江橙兰会快捷解决员工录用调档、培训、绩效考核、社会保险金和公积金转移等等提供
                                    一系列专业高效的人事事务外包，为企业规避风险，提升人事管理的效率和核心竞争力，使管理者能有更多的精力，投入到激烈的市场竞争中去。</p>
                            </div>
                            <img src="@/assets/img/serve01.png">
                        </div>
                        <div class="serve_body_title">
                            <h4>劳务外包<span>Service outsourcing</span></h4>
                        </div>
                    </div>
                    <div class="serve_body_item" ref="itemTwo">
                        <div class="serve_body_pic">
                            <div class="serve_body_text">
                                <p>人事代理服务是浙江橙兰一体化人力资源服务的重要内容之。受用人单位委托，承担专业性的人事事务管理工作，企业与浙江橙兰签订人事代理合同，为企业办理社会保险、托管档案、户籍挂靠、代发薪水等日常行政事务，实现人档分离和社会化管理。借助浙江橙兰建立企业规范化管理，使企业行为更具效率。
                                </p>
                            </div>
                            <img src="@/assets/img/serve02.png">
                        </div>
                        <div class="serve_body_title">
                            <h4>人事代理<span>Personnel agency</span></h4>
                        </div>
                    </div>
                    <div class="serve_body_item" ref="itemThree">
                        <div class="serve_body_pic">
                            <div class="serve_body_text">
                                <p>薪酬服务是指浙江橙兰根据客户提供的数据，为客户完成每月的薪资核算项目统计、薪资计算、发放等工作。帮助客户清算员工个人所得税、企业所得税、年度所得税等相关事务的处理。浙江橙兰还为客户提供税收政策、会计制度咨询等服务，帮助客户适时调整与优化薪酬结构，提升人力资源管理的核心竞争力，提高企业员工凝聚力，为企业创造价值。
                                </p>
                            </div>
                            <img src="@/assets/img/serve03.png">
                        </div>
                        <div class="serve_body_title">
                            <h4>薪酬服务<span>Pay service</span></h4>
                        </div>
                    </div>
                    <div class="serve_body_item" ref="itemFour">
                        <div class="serve_body_pic">
                            <div class="serve_body_text">
                                <p>劳务派遣是浙江橙兰一体化人力资源服务的重要内容之一。劳务派遣指由浙江橙兰作为雇员的法定雇主，企业同浙江橙兰公司签订人才派遣合同，企业负责派遣雇员的工作管理，浙江橙兰负责派遣雇员的人事管理，包括：人员聘用、员工档案接转建立、薪酬发放、缴纳社会保险、工伤申报劳动纠纷处理等事务性工作。轻松达到“用人不管人，增效不增支”的最大人力资源管理效益。
                                </p>
                            </div>
                            <img src="@/assets/img/serve04.png">
                        </div>
                        <div class="serve_body_title">
                            <h4>劳务派遣<span>Labor dispatch</span></h4>
                        </div>
                    </div>
                    <div class="serve_body_item" ref="itemFive">
                        <div class="serve_body_pic">
                            <div class="serve_body_text">
                                <p>招聘服务是指用工单位将全部或部分招聘、甄选工作委托给浙江橙兰资源，浙江橙兰利用自身在人才资源、评价工具和流程管理方面的优势来完成招聘工作的一种方式。浙江橙兰针对企业的实际需求提供招聘外包服务，利用专业的招聘团队、渠道优势等，与强大的人事外包服务有效衔接，为企业提供一对一的快速响应服务，解决企业用人后顾之忧。
                                </p>
                            </div>
                            <img src="@/assets/img/serve05.png">
                        </div>
                        <div class="serve_body_title">
                            <h4>招聘服务<span>Recruitment services</span></h4>
                        </div>
                    </div>
                    <div class="serve_body_item" ref="itemSix">
                        <div class="serve_body_pic">
                            <div class="serve_body_text">
                                <p>为客户提供中高端人才及特殊岗位的猎头及相关咨询服务，公司具有强大的人才简历库积累和收集能力的优势，强大的职位搜索引擎，精确的人才库定位，承诺严格按照服务流程，为客户提供快捷、高质量的人才猎头服务。
                                </p>
                            </div>
                            <img src="@/assets/img/serve06.png">
                        </div>
                        <div class="serve_body_title">
                            <h4>猎头服务<span>Headhunting service</span></h4>
                        </div>
                    </div>
                    <div class="serve_body_item" ref="itemSeven">
                        <div class="serve_body_pic">
                            <div class="serve_body_text">
                                <p>商务代理服务是浙江橙兰一体化人力资源服务之一。商务代理指浙江橙兰受企业的委托，为客户提供代表处的设立、变更、延期、注销，以及独资、合资、合作企业的设立、年检服务等一系列注册代理服务。并提供办公场地租赁、公共秘书、日常行政等服务。浙江橙兰致力于为客户提供一站式商务外包服务，简化办事流程，让企业更专注核心经营管理。
                                </p>
                            </div>
                            <img src="@/assets/img/serve07.png">
                        </div>
                        <div class="serve_body_title">
                            <h4>商务代理<span>Business agency</span></h4>
                        </div>
                    </div>
                    <div class="serve_body_item" ref="itemEight">
                        <div class="serve_body_pic">
                            <div class="serve_body_text">
                                <p>专业提供劳动人事法律服务<br />
                                    战略合作单位：浙江国傲律师事务所<br />
                                    特邀顾问律师：沈晓炳<br />
                                    劳动法律服务外包8元/人（按月）</p>
                            </div>
                            <img src="@/assets/img/serve08.png">
                        </div>
                        <div class="serve_body_title">
                            <h4>法务帮助<span>Legal help</span></h4>
                        </div>
                    </div>
                    <div class="serve_body_item" ref="itemNine">
                        <div class="serve_body_pic">
                            <div class="serve_body_text">
                                <p>商业险代理是浙江橙兰资源服务内容之一，公司向中国人寿、中国平安、泰康人寿等诸多商业保险服务机构购置团体商业险，凭借人数众多优势，享受商业保险理赔快捷、高效、实惠的服务。
                                </p>
                            </div>
                            <img src="@/assets/img/serve09.png">
                        </div>
                        <div class="serve_body_title">
                            <h4>商业保险<span>Commercial insurance</span></h4>
                        </div>
                    </div>
                    <div class="serve_body_item" ref="itemTen">
                        <div class="serve_body_pic">
                            <div class="serve_body_text">
                                <p>体检服务是浙江橙兰安排入职体检和年度保健体检服务，由常年合作体检机构安排上门服务。在员工关爱的健康管理服务中，注重提高员工的个人用户体验，协助员工享受快捷，方便的健康服务。
                                </p>
                            </div>
                            <img src="@/assets/img/serve10.png">
                        </div>
                        <div class="serve_body_title">
                            <h4>体检服务<span>A medical service</span></h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <friend></friend>
        <foots @navChange="clickFoot"></foots>
    </div>
</template>
<script>
    import friend from '@/components/friend.vue'
    import banner from '@/components/banner.vue'
    import navs from '@/components/navs.vue'
    import foots from '@/components/foots.vue'
    import bannerImg from '@/assets/img/serve_banner.png'
    export default {
        data() {
            return {
                bannerImg: bannerImg,
                activeName: 'first',

            }
        },


        mounted() {
            if (this.$route.params.type != null) {
                this.clickFoot(this.$route.params.type)
            } else {
                window.scrollTo(0, 0);
            }
        },

        methods: {

            //点击底部定位
            clickFoot(a) {
                debugger
                if (a == 0) {
                    this.$refs.itemOne.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                    this.activeName = 'first'
                }
                if (a == 1) {
                    this.$refs.itemTwo.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                    this.activeName = 'second'
                }
                if (a == 2) {
                    this.$refs.itemFour.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                    this.activeName = 'third'
                }
                if (a == 3) {
                    this.$refs.itemFour.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                    this.activeName = 'fourth'
                }
                if (a == 4) {
                    this.$refs.itemFive.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                    this.activeName = 'fifth'
                }
                if (a == 5) {
                    this.$refs.itemSix.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                    this.activeName = 'sixth'
                }
                if (a == 6) {
                    this.$refs.itemSeven.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                    this.activeName = 'seventh'
                }
                if (a == 7) {
                    this.$refs.itemEight.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                    this.activeName = 'eighth'
                }
                if (a == 8) {
                    this.$refs.itemNine.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                    this.activeName = 'ninth'
                }
                if (a == 9) {
                    this.$refs.itemTen.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                    this.activeName = 'tenth'
                }

            },



            handleClick(a, b) {
                if (a.index == 0) {
                    this.$refs.itemOne.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                }
                if (a.index == 1) {
                    this.$refs.itemTwo.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                }
                if (a.index == 2) {
                    this.$refs.itemThree.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                }
                if (a.index == 3) {
                    this.$refs.itemFour.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                }
                if (a.index == 4) {
                    this.$refs.itemFive.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                }
                if (a.index == 5) {
                    this.$refs.itemSix.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                }
                if (a.index == 6) {
                    this.$refs.itemSeven.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                }
                if (a.index == 7) {
                    this.$refs.itemEight.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                }
                if (a.index == 8) {
                    this.$refs.itemNine.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                }
                if (a.index == 9) {
                    this.$refs.itemTen.scrollIntoView({
                        behavior: 'smooth', //顺滑的滚动
                    })
                }
            }
        },
        components: {
            navs,
            foots,
            banner,
            friend
        }
    }
</script>
<style lang="scss" scoped>
    .serve_box {
        margin-bottom: 75px;
        padding-top: 80px;
    }

    .serve_body_title {
        text-align: left;

        h4 {
            font-size: 18px;
            color: #333;
            font-weight: 400;

            span {
                font-size: 12px;
                color: #999;
                font-weight: 400;
                margin-left: 17px;
            }
        }
    }

    .serve_body_list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 70px;
    }

    .serve_body_item:hover {

        .serve_body_text {
            bottom: 0 !important;
            transition: all .5s;
        }
    }

    .serve_body_item {
        width: 46%;
        margin-bottom: 100px;

        .serve_body_pic {
            position: relative;
            overflow: hidden;
            border-radius: 15px;

            img {
                width: 100%;
            }

            .serve_body_text {
                position: absolute;
                background: rgba(0, 0, 0, .4);
                width: 100%;
                height: 100%;
                color: #fff;
                text-align: left;
                bottom: -500px;
                transition: all .3s;

                p {
                    position: absolute;
                    margin: 0;
                    line-height: 30px;
                    bottom: 0;
                    left: 0;
                    box-sizing: border-box;
                    padding: 40px 50px;
                }
            }
        }
    }
</style>
<style lang="scss">
    .serve_nav_list {
        .el-tabs__nav-wrap::after {
            height: 0 !important;
        }

        .el-tabs__item {
            font-size: 16px;
            padding: 0 24px;
        }

        .el-tabs__item.is-active {
            color: #F08300
        }

        .el-tabs__active-bar {
            background-color: #F08300;
        }

        .el-tabs__item:hover {
            color: #F08300;
        }
    }
</style>